import { Button, IconButton, SvgIcon } from '@mui/material';
import React from 'react';
import { borderRadius, boxShadows, palette } from '../../assets/styles/themes/tokens';
import getMuiIcon from '../../utils/getMuiIcon';
import { useTranslation } from 'react-i18next';

const AIButton: React.FC<{
    isClassic?: boolean
    isActive: boolean
    onClick: VoidFunction
    disabled?: boolean
    buttonType: 'round' | 'rectangular'
}> = ({ isActive, onClick, disabled, isClassic = false, buttonType }) => {
  const { t } = useTranslation();

  // Base styles shared by both variants
  const baseStyles = {
    round: {
      position: 'relative',
      borderRadius: borderRadius.full,
      boxShadow: boxShadows.elevation3,
      '&:disabled': {
        backgroundColor: palette.action.disabledBackground,
      }
    },
    rectangular: {},
  };

  const rectangualarButtonStyles = {
    ...(isClassic ? {
      backgroundColor: palette.background.paperElevation2,
      borderRadius: borderRadius.xxs
    } : {}),
    ...(isActive ? { backgroundColor: palette.primary.contrast } : {}),
  };

  const roundButtonStyles = isClassic ? {
    ...baseStyles.round,
    backgroundColor: palette.primary.contrast,
    border: `1px solid ${isActive ? palette.primary.focusVisible : palette.primary.main}`,
    '&:hover': {
      backgroundColor: palette.primary.contrast,
      borderColor: palette.primary.focusVisible,
    },
  } : {
    ...baseStyles.round,
    backgroundColor: isActive ? palette.primary.light : palette.primary.main,
    '&:hover': {
      backgroundColor: palette.primary.dark,
    },
  };

  const iconColor = isClassic 
    ? palette.primary.main : disabled 
      ? palette.secondary.contrastText : palette.primary.contrast;

  return buttonType === 'round' ? 
    (<IconButton
      data-testid='ai-assistant-button'
      onClick={onClick}
      disabled={disabled}
      sx={roundButtonStyles}
      type='button'
      aria-label={t('Generate AI suggestions')}
    >
      <SvgIcon
        sx={{ 
          width: 24,
          height: 24,
          color: iconColor
        }}
        viewBox='0 0 24 24'
        component={getMuiIcon('ai')}
        aria-hidden='true'
      /> 
    </IconButton>
    ) : (
      <Button
        data-testid='ai-assistant-button'
        onClick={onClick}
        disabled={disabled}
        variant='outlined'
        size='large'
        sx={rectangualarButtonStyles}
        type='button'
        aria-label={t('Generate AI suggestions (short)')}        
        startIcon={<SvgIcon component={getMuiIcon('ai')} aria-hidden='true' />}
      >
        {t('Generate AI suggestions (short)')}
      </Button>
    );
};

export default AIButton;
